<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Employee
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm"
            >Delete</b-button
          >
          <b-button variant="primary mr-1" @click="printcv"
            ><i class="fa fa-print"></i> CV</b-button
          >
          <b-button variant="primary mr-1" @click="printpeklaring"
            ><i class="fa fa-print"></i> Peklaring</b-button
          >
          <b-button variant="primary mr-1" @click="exportxls()"
            ><i class="fa fa-file-excel-o"></i>Export</b-button
          >
          <b-button variant="primary mr-1" @click="showFilter = !showFilter"
            ><i class="fa fa-filter"></i> Filter</b-button
          >
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close</b-button
          >
        </div>
      </div>
      <b-row v-if="showFilter" class="ml-2 mr-2 filter">
        <b-col lg="8">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Report To</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.managerinfo"
                  placeholder="Manager Name"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Project</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="tblData.projectname"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCustomerShow = true"
                    ><i class="fa fa-search"></i
                  ></b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Department</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.departemen"
                  placeholder="Departmenet Name"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Pendidikan</label></b-input-group-prepend
                >
                <b-form-input v-model="tblData.pendidikan"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Job Title</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.jabatan"
                  placeholder="Job Title"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Company</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="tblData.compcode"
                  :options="companiesOpt"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Skill</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.skill"
                  placeholder="Certificates/License"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Working Experience</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="tblData.industryExperience"
                  placeholder="Industry Working Experience"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><label>Employee </label></b-input-group-prepend
            >
            <b-form-input
              v-model="tblData.crewname"
              placeholder="Name"
              style="width: 45% !important"
            ></b-form-input>
            <b-form-input
              v-model="tblData.crewnik"
              placeholder="ID Number"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label>Shift/Non Shift</label></b-input-group-prepend
            >
            <b-form-select
              v-model="tblData.officer"
              :plain="true"
              :options="officerStatus"
            ></b-form-select>
            <b-input-group-append
              ><label class="pt-2"
                >&nbsp; Active &nbsp;</label
              ></b-input-group-append
            >
            <b-form-select
              v-model="tblData.terminate"
              :plain="true"
              :options="activeStatus"
            ></b-form-select>
          </b-input-group>


          <b-input-group>
            <b-input-group-prepend><label>Join Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Terminate Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl3" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl4" type="date"></b-form-input>
          </b-input-group>

          <b-input-group>
            <!-- <b-input-group-prepend><label >&nbsp;</label></b-input-group-prepend> -->
            <b-input-group-prepend
              ><label>Umur/Usia</label></b-input-group-prepend
            >
            <b-form-input v-model="tblData.usia1"></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text">-</span></b-input-group-prepend
            >
            <b-form-input v-model="tblData.usia2"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="search()">
                <i class="fa fa-refresh"></i> Apply Filter</b-button
              >
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mt-2 mb-0 text-nowrap"
        ref="tblEmployee"
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="data"
        :fields="fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="selectEmployee"
        show-empty
      >
        <template v-slot:cell(crewaddr)="data">
          <div
            style="
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              max-width: 300px !important;
              font-size: smaller;
            "
          >
            {{ data.item.crewaddr }}
          </div>
        </template>

        <template v-slot:cell(joinDate)="data">
          <span v-if="data.item.joinDate">{{
            data.item.joinDate | moment("DD-MMM-YY")
          }}</span>
        </template>
        <template v-slot:cell(terminateDate)="data">
          <span v-if="data.item.terminateDate">{{
            data.item.terminateDate | moment("DD-MMM-YY")
          }}</span>
        </template>
        <template v-slot:cell(crewdob)="data">
          <span v-if="data.item.crewdob">{{
            data.item.crewdob | moment("DD-MMM-YY")
          }}</span>
        </template>
        <template v-slot:cell(staffTetap)="data">
          <span v-if="data.item.staffTetap == 1">Tetap</span>
          <span v-else>PKWT</span>
        </template>
        <template v-slot:cell(officer)="data">
          <span v-if="data.item.officer == 1">Daily</span>
          <span v-else>Shift</span>
        </template>
        <template v-slot:cell(overtimeable)="data">
          <span v-if="data.item.overtimeable == 1">Eligible</span>
          <span v-else>No</span>
        </template>
        <template v-slot:cell(workingtime)="data">
          {{ data.item.workingtime }} hours
        </template>
        <template v-slot:cell(terminate)="data">
          <span v-if="data.item.terminate == 0">Yes</span>
          <span v-else>No</span>
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.crew)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click="deleteConfirm(data.crew)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
      </b-table>
      <b-row class="mt-1">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]"
              :plain="true"
              v-model="tblData.limit"
              style="width: 80px"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            v-if="pagination"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      v-model="showDelConfirm"
      title="Delete Record?"
      :centered="true"
      @ok="deleteData"
    >
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="List of Client/Project"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>
  </div>
</template>
<style lang="scss">
.filter {
  .input-group {
    padding-bottom: 2px;

    .input-group-prepend {
      label {
        padding-top: 5px;
        padding-right: 5px;
        width: 110px;
      }
    }
  }
}

iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}
</style>
<script>
import Loading from "vue-loading-overlay";
import toastr from "mini-toastr";
toastr.init();

import crew from "../../apis/crewhr";
import crud from "../../apis/crud";
import lkuCustomer from "../lookup/lkuCustomers";
export default {
  components: { Loading, lkuCustomer },
  data() {
    return {
      fields: [
        {
          key: "crewnik",
          label: "Employee ID",
          thStyle: "width:100px",
          sortable: true,
        },
        {
          key: "crewname",
          label: "Employee Name",
          thStyle: "width:250px",
          sortable: true,
        },
        {
          key: "jabatan",
          label: "Job Title",
          thStyle: "width:150px",
        },
        {
          key: "managerinfo",
          thStyle: "width:150px",
          label: "Atasan/manager",
          sortable: true,
        },
        {
          key: "pendidikan",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
          label: "Pendidikan",
        },
        {
          key: "crewdob",
          thStyle: "width:90px",
          thClass: "text-center",
          tdClass: "text-center",
          label: "D.O.B",
          sortable: true,
        },
        {
          key: "crewaddr",
          thClass: "text-center",
          label: "Alamat Tinggal",
          sortable: true,
        },
        {
          key: "staffTetap",
          thStyle: "width:60px",
          label: "Type",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "officer",
          thStyle: "width:40px",
          label: "Shift/Daily",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "overtimeable",
          thStyle: "width:40px",
          label: "OverTime",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "locationname",
          label: "Location",
          sortable: true,
        },
        {
          key: "company",
          label: "Company",
          sortable: true,
        },
        {
          key: "workingtime",
          thStyle: "width:40px",
          label: "Working Time",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "departemen",
          label: "Department",
          thStyle: "width:150px",
          sortable: true,
        },
        {
          key: "joinDate",
          thStyle: "width:90px",
          label: "Join Date",
          sortable: true,
        },
        {
          key: "joinDate",
          thStyle: "width:90px",
          label: "Join Date",
          sortable: true,
        },
        {
          key: "terminateDate",
          thStyle: "width:90px",
          label: "Terminate Date",
          sortable: true,
        },
        {
          key: "projectname",
          thStyle: "width:120px",
          label: "Project",
          sortable: true,
        },
        {
          key: "terminate",
          thStyle: "width:90px",
          label: "Active",
          sortable: true,
        },
      ],
      pagination: false,
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
        terminate: "0",
        compcode: "",
        tgl1: '',
        tgl2: '',
        tgl3: '',
        tgl4: '',
        skill:'',industryExperience:''
      },
      model: {},
      crewImg: [
        { imgDataUrl: "", imgKey: "0" },
        { imgDataUrl: "", imgKey: "1" },
        { imgDataUrl: "", imgKey: "2" },
        { imgDataUrl: "", imgKey: "3" },
      ],
      imgParams: { name: "gambar" },
      imgHeaders: {},
      imgDataUrl: "",
      imgUploadUrl: "",
      img3: "",
      imgIndex: 0,
      horizontal: true,
      isLoading: false,
      showDelConfirm: false,
      showFilter: false,
      lkuCustomerShow: false,
      showImgTool: false,
      showList: true,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      activeStatus: [
        { value: "", text: "-- ALL --" },
        ,
        { value: "0", text: "Yes" },
        { value: "1", text: "No" },
      ],
      officerStatus: [
        { value: "", text: "-- ALL --" },
        ,
        { value: "0", text: "Shift/Scheduled Worker" },
        { value: "1", text: "Office/Daily Worker" },
      ],
      tblDataCompany: {
        tablename: "company",
        page: 1,
        total: 0,
        limit: 1000,
        sortBy: "company",
        sortDesc: false,
      },
      companiesOpt: [],
    };
  },
  async created() {
    this.tblDataCompany.sortDir = this.tblDataCompany.sortDesc ? "desc" : "asc";
    const company = await crud.list(this.tblDataCompany);
    let companiesOpt = [{ value: "", text: "-- ALL --" }];
    company.map((dt) => {
      companiesOpt.push({ value: dt.compcode, text: dt.company });
    });
    this.companiesOpt = companiesOpt;
    // this.companiesOpt = company.reduces((arr=[{value:'',text:'-- ALL --'}])=>{
    //   return arr;
    // },[]);
  },

  methods: {
    onSelectLkuCustomer: async function (_selected) {
      this.tblData.projectname =
        _selected.CustName.trim() + " | " + _selected.CustCode.trim();
      this.tblData.projectid = _selected.customer_id;
      this.lkuCustomerShow = false;
    },
    selectEmployee(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      const tblOrder = {
        sortBy: this.tblData.sortBy,
        sortDesc: this.tblData.sortDesc,
      };
      this.pagination = false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.crewlist) {
        this.tblData[key] = filter.crewlist[key];
        filtered = true;
      }
      if (filtered === true) {
        this.tblData.tgl1 = filter.crewlist.tgl1 || "";
        this.tblData.tgl2 = filter.crewlist.tgl2 || "";
        this.tblData.tgl3 = filter.crewlist.tgl3 || "";
        this.tblData.tgl4 = filter.crewlist.tgl4 || "";

        this.showFilter = filtered;
        delete filter.crewlist;
        this.$store.commit("filter", filter);
        let autoRefresh = true;
        if (this.tblData.page == 1) {
          if (
            tblOrder.sortBy == this.tblData.sortBy &&
            tblOrder.sortDesc == this.tblData.sortDesc
          ) {
            autoRefresh = false;
          } else autoRefresh = true;
        }
        if (autoRefresh == false) {
          this.isLoading = true;
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          try {
            const list = await crew.list(this.tblData);
            this.pagination = true;
            this.isLoading = false;
            return list;
          } catch (error) {
            this.isLoading = false;
            if (error.sql) {
              toastr.error(error.sql, "ERROR MESSAGE", 10000);
            } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
            } else if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        this.isLoading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        try {
          const list = await crew.list(this.tblData);
          this.pagination = true;
          this.isLoading = false;
          return list;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    search(ctx) {
      this.tblData.page = 1;
      this.refresh();
    },
    refresh() {
      this.$refs.tblEmployee.refresh();
    },
    clearFilter(ctx) {
      this.tblData.crewcode = "";
      this.tblData.crewname = "";
      this.tblData.departemen = "";
      this.tblData.pendidikan = "";
      this.tblData.group = "";
      this.tblData.officer = "";
      this.tblData.terminate = "";
      this.tblData.projectid = "";
      this.tblData.projectname = "";
      this.tblData.pendidikan = "";
      this.tblData.usia1 = "";
      this.tblData.usia2 = "";
      this.tblData.compcode = "";
      this.tblData.skill='';
      this.tblData.industryExperience='';
      this.tblData.crewnik='';
      this.tblData.managerinfo='';
      this.tblData.jabatan='';
      this.tblData.tgl1='';
      this.tblData.tgl2='';
      this.tblData.tgl3='';
      this.tblData.tgl4='';
      // this.refresh();
    },
    saveFilter() {
      const keys = [
        "compcode",
        "crewnik",
        "crewname",
        "jabatan",
        "departemen",
        "pangkat",
        "golongan",
        "managerinfo",
        "terminate",
        "officer",
        "projectid",
        "projectname",
        "pendidikan",
        "usia1",
        "usia2",
      ];
      let filtered = false;
      const crewlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          crewlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        crewlist.page = this.tblData.page;
        crewlist.limit = this.tblData.limit;
        crewlist.sortBy = this.tblData.sortBy;
        crewlist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.crewlist = crewlist;
        this.$store.commit("filter", filter);
      }
    },

    add: function (data) {
      this.saveFilter();
      router.push({ name: "hrm.employeefrm" });
    },
    edit: function () {
      if (this.model) {
        this.saveFilter();
        router.push({
          name: "hrm.employeefrm",
          params: { crewkey: this.model.crewkey },
        });
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      await crew.remove(this.model);
      this.refresh();
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        const response = await crew.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "Error Info", 10000);
        } else {
          toastr.error(JSON.stringify(error), "Error Info", 10000);
        }
      }
    },
    printcv: async function () {
      if (this.model.crewkey) {
        try {
          this.showReport = true;
          this.reportUrl = await crew.printcv(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "Error Info", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "Error Info", 10000);
          } else {
            toastr.error(JSON.stringify(error), "Error Info", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printpeklaring: async function () {
      if (this.model.crewkey) {
        try {
          this.showReport = true;
          this.reportUrl = await crew.printpeklaring(this.model);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "Error Info", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "Error Info", 10000);
          } else {
            toastr.error(JSON.stringify(error), "Error Info", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },

    closeFrm() {
      this.showList = true;
    },
    close() {
      router.push("home");
    },
  },
};
</script>
